import * as Types from '../action-types';
import update from 'immutability-helper';

let gDataReducer = function(state = {}, action) {
    switch (action.type) {
        case Types.SET_HEADER_INFO:
            return update(state, { headerInfo: { $set: action.headerInfo } });

        case Types.SET_GLOBAL_HOTEL:
            return update(state, {
                hotel: { $set: action.hotel },
                roomCategory: { $set: null }
            });

        case Types.SET_GLOBAL_ROOM_CATEGORY:
            return update(state, {
                roomCategory: { $set: action.roomCategory }
            });

        default:
            return state;
    }
};

export default gDataReducer;
